/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ComparisonDropdowns,
  ComparisonDropdownsFromJSON,
  ComparisonDropdownsFromJSONTyped,
  ComparisonDropdownsToJSON,
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
} from "./";

/**
 *
 * @export
 * @interface ComparisonDropdownsControllerResponse
 */
export interface ComparisonDropdownsControllerResponse {
  /**
   *
   * @type {ComparisonDropdowns}
   * @memberof ComparisonDropdownsControllerResponse
   */
  data?: ComparisonDropdowns;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ComparisonDropdownsControllerResponse
   */
  error?: ErrorResponse;
}

export function ComparisonDropdownsControllerResponseFromJSON(json: any): ComparisonDropdownsControllerResponse {
  return ComparisonDropdownsControllerResponseFromJSONTyped(json, false);
}

export function ComparisonDropdownsControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ComparisonDropdownsControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : ComparisonDropdownsFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ComparisonDropdownsControllerResponseToJSON(value?: ComparisonDropdownsControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: ComparisonDropdownsToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
